/**
 * [INPUT]: 依赖 ../scorer 的 ScoreReport 与 tierOf
 * [OUTPUT]: 对外提供 shareText(report)、DISCLAIMER、PRIVACY_POINTS
 * [POS]: apps/web/report 的文案层，组装分享文案与免责/隐私要点；对齐 docs §6/§8 文案原则
 * [PROTOCOL]: 变更时更新此头部，然后检查 ../../CLAUDE.md
 */
import { tierOf, type ScoreReport } from '../scorer'

export const DISCLAIMER = 'Heuristic score based on facial proportions. For entertainment only — not a scientific, medical, or employment standard.'

export const PRIVACY_POINTS = [
  'Your photo is processed entirely on your device',
  'We never see your face by default',
  'If you choose to save a report, we only store scores and metrics — never your photo',
]

export function shareText(report: ScoreReport): string {
  const { tier } = tierOf(report.total)
  return [
    `My PSL Score: ${report.total.toFixed(1)}/8 · ${tier}`,
    `Harmony ${report.main_scores.harmony.toFixed(1)} · Dimorphism ${report.main_scores.dimorphism.toFixed(1)} · Angularity ${report.main_scores.angularity.toFixed(1)} · Presentation ${report.main_scores.presentation.toFixed(1)}`,
    DISCLAIMER,
  ].join('\n')
}